import styled from "styled-components";

import { Icon as _Icon } from "_/components/icon";

import { ProjectInfoValue } from "../styled";

export { ProjectInfoLabel, ProjectInfoValue, ProjectInfoItem } from "../styled";

export const ProjectInfoLabelRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const EditButton = styled.button`
  display: inline-flex;
  align-items: center;

  background: none;
  border: none;
  padding: 0;
  cursor: pointer;

  font-size: 1rem;
  color: ${(p) => p.theme.text.muted};
`;

export const InstructionsValueWrapper = styled.div`
  position: relative;
`;

export const InstructionsValue = styled(ProjectInfoValue)<{
  $expanded: boolean;
}>`
  /* Preserve user-entered line breaks, and wrap long unbroken text instead of
     letting it overflow the sidebar's fixed width. */
  white-space: pre-wrap;
  overflow-wrap: break-word;

  ${(p) =>
    !p.$expanded &&
    `
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
    `}
`;

// An unset value is different from instructions that happen to be short, so
// give it a subdued treatment rather than presenting it as instruction text.
export const EmptyInstructionsValue = styled(ProjectInfoValue)`
  color: ${(p) => p.theme.text.muted};
  font-style: italic;
`;

// Fades the last visible line into the containing project's info background,
// hinting that there's more text below.
export const InstructionsFade = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 1.5em;
  pointer-events: none;
  background: linear-gradient(
    transparent,
    ${(p) => p.theme.background.secondary}
  );
`;

export const ShowMoreToggle = styled.button<{ $expanded: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;

  background: none;
  border: none;
  padding: 0;
  cursor: pointer;

  color: ${(p) => p.theme.link.default};
  font-size: 0.875rem;

  &:hover {
    color: ${(p) => p.theme.link.hover};
  }

  ${_Icon} {
    font-size: 1.125rem;
    transition: transform 0.15s ease;
    transform: rotate(${(p) => (p.$expanded ? "180deg" : "0deg")});
  }
`;
